/**
 * ─────────────────────────────────────────────────────────────────────────────
 * AgroCast — Theme Context
 * ─────────────────────────────────────────────────────────────────────────────
 *
 * Provides a React Context on top of the Zustand theme store.
 * This enables:
 *  - Passing theme values without prop-drilling
 *  - Being consumed by components outside the Zustand scope (e.g. portals)
 *  - Clean import: `const { resolvedTheme } = useTheme()`
 * ─────────────────────────────────────────────────────────────────────────────
 */

import { createContext } from 'react'
import { THEMES }        from './tokens'

/**
 * ThemeContext shape — mirrors the store's public surface.
 * Default values are used if consumed outside <ThemeProvider>.
 */
export const ThemeContext = createContext({
  // State
  preference:      THEMES.SYSTEM,
  resolvedTheme:   THEMES.LIGHT,
  isTransitioning: false,

  // Derived booleans
  isDark:   false,
  isLight:  true,
  isSystem: true,

  // Actions
  setTheme:          () => {},
  toggleTheme:       () => {},
  resetToSystem:     () => {},
})